import React from "react";

type VariablesContextType = { variables: Record<string, any> };

export const VariablesContext = React.createContext<VariablesContextType>(
  null!,
);
